"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const categoryKeys = [
  "blog.catPricing",
  "blog.catComparison",
  "blog.catInsurance",
  "blog.catCodes",
  "blog.catMaintenance",
];

export default function CategoriesStrip() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#fefce8] py-8">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-center justify-center gap-3">
          {categoryKeys.map((key) => (
            <span
              key={key}
              className="cursor-pointer whitespace-nowrap rounded-full border border-[#064e3b]/15 bg-white px-5 py-2 text-sm font-medium text-[#064e3b] transition hover:border-[#fbbf24] hover:bg-[#fbbf24] hover:text-[#064e3b]"
            >
              {t(key)}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}